var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalanderWithSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 292,
    viewBox: "0 0 324 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.74 103.51H271.74",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.24 73.51V28.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.74 73.51V28.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M196.74 73.51V28.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.24 73.51V28.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M234.24 73.51V28.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.74 238.51C271.74 242.488 270.16 246.304 267.347 249.117C264.534 251.93 260.718 253.51 256.74 253.51H61.74C57.7617 253.51 53.9464 251.93 51.1334 249.117C48.3203 246.304 46.74 242.488 46.74 238.51V51H271.74V238.51Z",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.24 133.51V163.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.24 133.51V163.51",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.24 133.51H114.24",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.24 163.51H84.24",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M159.17 148.51H159.32",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 148.51H219.32",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M159.17 208.51H159.32",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.17 208.51H99.32",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.17 208.51H219.32",
    stroke: "white",
    strokeWidth: 11.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalanderWithSquare);
export default __webpack_public_path__ + "static/media/calanderWithSquare.96b3174c715af322ef7fa7f5a97a8912.svg";
export { ForwardRef as ReactComponent };